const _w = atob('bmlnZ2VyLG5pZ2dhLG5pZyxjaGluayxzcGljLGdvb2ssamFwLGtpa2Usd2V0YmFjayxwYWtpLGJlYW5lcixyZWRza2luLHJhZ2hlYWQsdG93ZWxoZWFkLGRhZ28sZmFnZ290LGZhZ2dpdCxmYWdvdCxmYWcsZHlrZSxuYXppLHBlZG8sbW9sZXN0LGJlc3RpYWxpdHkscmFwZSxyYXBpc3QscmV0YXJkLHRyYW5ueQ==').split(',');

// Check if text contains any blocked words.
// Two passes:
// 1. Per-token — short blocked words (< 5 chars) require exact match to avoid
//    false positives on legitimate words that happen to contain those letters.
//    Longer blocked words use substring matching to catch character-substitution
//    obfuscation within a word.
// 2. Full-strip — catches spaced-out attempts by removing all non-letters from
//    the entire string. Only applied to blocked words of 5+ characters to
//    reduce cross-word false positive risk.
export const containsProfanity = (text) => {
  if (!text) return false;

  const lower = text.toLowerCase();

  // Pass 1: per-token
  for (const token of lower.split(/\s+/)) {
    const cleaned = token.replace(/[^a-z]/g, '');
    if (cleaned.length < 3) continue;
    for (const blocked of _w) {
      if (blocked.length >= 5) {
        if (cleaned.includes(blocked)) return true;
      } else {
        if (cleaned === blocked) return true;
      }
    }
  }

  // Pass 2: full strip for longer words (catches spaced-out slurs)
  const fullyStripped = lower.replace(/[^a-z]/g, '');
  for (const blocked of _w) {
    if (blocked.length >= 5 && fullyStripped.includes(blocked)) return true;
  }

  return false;
};

export const cleanText = (text) => {
  if (!text) return text;
  return text
    .split(/\s+/)
    .map((token) => {
      const cleaned = token.toLowerCase().replace(/[^a-z]/g, '');
      for (const blocked of _w) {
        if (blocked.length >= 5) {
          if (cleaned.includes(blocked)) return '****';
        } else {
          if (cleaned === blocked) return '****';
        }
      }
      return token;
    })
    .join(' ');
};
